import { useState } from 'react';

interface CategorySearchFiltersProps {
  onSearch: (keyword: string) => void;
  onStatusChange: (status: string) => void;
}

export default function CategorySearchFilters({ onSearch, onStatusChange }: CategorySearchFiltersProps) {
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('');

  const handleSearch = () => {
    onSearch(keyword);
  };

  const handleStatusChange = (value: string) => {
    setStatus(value);
    onStatusChange(value);
  };

  const handleReset = () => {
    setKeyword('');
    setStatus('');
    onSearch('');
    onStatusChange('');
  };

  return (
    <div className="bg-white rounded-lg p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">分类名称</label>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="支持模糊搜索"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">分类状态</label>
          <select
            value={status}
            onChange={(e) => handleStatusChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
          >
            <option value="">全部状态</option>
            <option value="true">正常</option>
            <option value="false">禁用</option>
          </select>
        </div>
      </div>

      <div className="flex gap-3">
        <button
          onClick={handleSearch}
          className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
        >
          <i className="ri-search-line mr-2"></i>
          搜索
        </button>
        <button
          onClick={handleReset}
          className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap"
        >
          <i className="ri-refresh-line mr-2"></i>
          重置
        </button>
      </div>
    </div>
  );
}
